/**
 * TanStack Query hooks for `entry-level-299-month`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	entryLevel299MonthQueryKeys,
	type CreateEntryLevel299MonthBody,
	type ListEntryLevel299MonthResponse,
	type EntryLevel299MonthRow,
} from "./api";

export function useEntryLevel299MonthList(): UseQueryResult<ListEntryLevel299MonthResponse, Error> {
	return useQuery({
		queryKey: entryLevel299MonthQueryKeys.list(),
		queryFn: list,
	});
}

export function useEntryLevel299MonthCreate(): UseMutationResult<EntryLevel299MonthRow, Error, CreateEntryLevel299MonthBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: entryLevel299MonthQueryKeys.all });
		},
	});
}

export function useEntryLevel299MonthDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: entryLevel299MonthQueryKeys.all });
		},
	});
}
